module.exports = __webpack_public_path__ + "img/Frame.2f6c68f3.png";